!(function (t) {
    if ('object' == typeof exports && 'undefined' != typeof module)
        module.exports = t();
    else if ('function' == typeof define && define.amd) define([], t);
    else {
        ('undefined' != typeof window
            ? window
            : 'undefined' != typeof global
            ? global
            : 'undefined' != typeof self
            ? self
            : this
        ).pica = t();
    }
})(function () {
    return (function a(o, A, s) {
        function u(e, t) {
            if (!A[e]) {
                if (!o[e]) {
                    var i = 'function' == typeof require && require;
                    if (!t && i) return i(e, !0);
                    if (h) return h(e, !0);
                    var r = new Error("Cannot find module '" + e + "'");
                    throw ((r.code = 'MODULE_NOT_FOUND'), r);
                }
                var n = (A[e] = { exports: {} });
                o[e][0].call(
                    n.exports,
                    function (t) {
                        return u(o[e][1][t] || t);
                    },
                    n,
                    n.exports,
                    a,
                    o,
                    A,
                    s
                );
            }
            return A[e].exports;
        }
        for (
            var h = 'function' == typeof require && require, t = 0;
            t < s.length;
            t++
        )
            u(s[t]);
        return u;
    })(
        {
            1: [
                function (t, e, i) {
                    'use strict';
                    var r = t('inherits'),
                        n = t('multimath'),
                        a = t('multimath/lib/unsharp_mask'),
                        o = t('./mm_resize');
                    function A(t) {
                        var e = t || [],
                            i = {
                                js: 0 <= e.indexOf('js'),
                                wasm: 0 <= e.indexOf('wasm'),
                            };
                        n.call(this, i),
                            (this.features = {
                                js: i.js,
                                wasm: i.wasm && this.has_wasm,
                            }),
                            this.use(a),
                            this.use(o);
                    }
                    r(A, n),
                        (A.prototype.resizeAndUnsharp = function (t, e) {
                            var i = this.resize(t, e);
                            return (
                                t.unsharpAmount &&
                                    this.unsharp_mask(
                                        i,
                                        t.toWidth,
                                        t.toHeight,
                                        t.unsharpAmount,
                                        t.unsharpRadius,
                                        t.unsharpThreshold
                                    ),
                                i
                            );
                        }),
                        (e.exports = A);
                },
                {
                    './mm_resize': 4,
                    inherits: 15,
                    multimath: 16,
                    'multimath/lib/unsharp_mask': 19,
                },
            ],
            2: [
                function (t, e, i) {
                    'use strict';
                    function w(t) {
                        return t < 0 ? 0 : 255 < t ? 255 : t;
                    }
                    e.exports = {
                        convolveHorizontally: function (t, e, i, r, n, a) {
                            var o,
                                A,
                                s,
                                u,
                                h,
                                f,
                                c,
                                g,
                                l,
                                I,
                                d,
                                m = 0,
                                p = 0;
                            for (l = 0; l < r; l++) {
                                for (I = h = 0; I < n; I++) {
                                    for (
                                        f = a[h++],
                                            c = a[h++],
                                            g = (m + 4 * f) | 0,
                                            o = A = s = u = 0;
                                        0 < c;
                                        c--
                                    )
                                        (u = (u + (d = a[h++]) * t[g + 3]) | 0),
                                            (s = (s + d * t[g + 2]) | 0),
                                            (A = (A + d * t[g + 1]) | 0),
                                            (o = (o + d * t[g]) | 0),
                                            (g = (g + 4) | 0);
                                    (e[p + 3] = w((u + 8192) >> 14)),
                                        (e[p + 2] = w((s + 8192) >> 14)),
                                        (e[p + 1] = w((A + 8192) >> 14)),
                                        (e[p] = w((o + 8192) >> 14)),
                                        (p = (p + 4 * r) | 0);
                                }
                                (p = (4 * (l + 1)) | 0),
                                    (m = ((l + 1) * i * 4) | 0);
                            }
                        },
                        convolveVertically: function (t, e, i, r, n, a) {
                            var o,
                                A,
                                s,
                                u,
                                h,
                                f,
                                c,
                                g,
                                l,
                                I,
                                d,
                                m = 0,
                                p = 0;
                            for (l = 0; l < r; l++) {
                                for (I = h = 0; I < n; I++) {
                                    for (
                                        f = a[h++],
                                            c = a[h++],
                                            g = (m + 4 * f) | 0,
                                            o = A = s = u = 0;
                                        0 < c;
                                        c--
                                    )
                                        (u = (u + (d = a[h++]) * t[g + 3]) | 0),
                                            (s = (s + d * t[g + 2]) | 0),
                                            (A = (A + d * t[g + 1]) | 0),
                                            (o = (o + d * t[g]) | 0),
                                            (g = (g + 4) | 0);
                                    (e[p + 3] = w((u + 8192) >> 14)),
                                        (e[p + 2] = w((s + 8192) >> 14)),
                                        (e[p + 1] = w((A + 8192) >> 14)),
                                        (e[p] = w((o + 8192) >> 14)),
                                        (p = (p + 4 * r) | 0);
                                }
                                (p = (4 * (l + 1)) | 0),
                                    (m = ((l + 1) * i * 4) | 0);
                            }
                        },
                    };
                },
                {},
            ],
            3: [
                function (t, e, i) {
                    'use strict';
                    e.exports =
                        'AGFzbQEAAAABFAJgBn9/f39/fwBgB39/f39/f38AAg8BA2VudgZtZW1vcnkCAAEDAwIAAQQEAXAAAAcZAghjb252b2x2ZQAACmNvbnZvbHZlSFYAAQkBAArmAwLBAwEQfwJAIANFDQAgBEUNACAFQQRqIRVBACEMQQAhDQNAIA0hDkEAIRFBACEHA0AgB0ECaiESAn8gBSAHQQF0IgdqIgZBAmouAQAiEwRAQQAhCEEAIBNrIRQgFSAHaiEPIAAgDCAGLgEAakECdGohEEEAIQlBACEKQQAhCwNAIBAoAgAiB0EYdiAPLgEAIgZsIAtqIQsgB0H/AXEgBmwgCGohCCAHQRB2Qf8BcSAGbCAKaiEKIAdBCHZB/wFxIAZsIAlqIQkgD0ECaiEPIBBBBGohECAUQQFqIhQNAAsgEiATagwBC0EAIQtBACEKQQAhCUEAIQggEgshByABIA5BAnRqIApBgMAAakEOdSIGQf8BIAZB/wFIG0EQdEGAgPwHcUEAIAZBAEobIAtBgMAAakEOdSIGQf8BIAZB/wFIG0EYdEEAIAZBAEobciAJQYDAAGpBDnUiBkH/ASAGQf8BSBtBCHRBgP4DcUEAIAZBAEobciAIQYDAAGpBDnUiBkH/ASAGQf8BSBtB/wFxQQAgBkEAShtyNgIAIA4gA2ohDiARQQFqIhEgBEcNAAsgDCACaiEMIA1BAWoiDSADRw0ACwsLIQACQEEAIAIgAyAEIAUgABAAIAJBACAEIAUgBiABEAALCw==';
                },
                {},
            ],
            4: [
                function (t, e, i) {
                    'use strict';
                    e.exports = {
                        name: 'resize',
                        fn: t('./resize'),
                        wasm_fn: t('./resize_wasm'),
                        wasm_src: t('./convolve_wasm_base64'),
                    };
                },
                {
                    './convolve_wasm_base64': 3,
                    './resize': 5,
                    './resize_wasm': 8,
                },
            ],
            5: [
                function (t, e, i) {
                    'use strict';
                    var d = t('./resize_filter_gen'),
                        m = t('./convolve').convolveHorizontally,
                        p = t('./convolve').convolveVertically;
                    e.exports = function (t) {
                        var e = t.src,
                            i = t.width,
                            r = t.height,
                            n = t.toWidth,
                            a = t.toHeight,
                            o = t.scaleX || t.toWidth / t.width,
                            A = t.scaleY || t.toHeight / t.height,
                            s = t.offsetX || 0,
                            u = t.offsetY || 0,
                            h = t.dest || new Uint8Array(n * a * 4),
                            f = void 0 === t.quality ? 3 : t.quality,
                            c = t.alpha || !1,
                            g = d(f, i, n, o, s),
                            l = d(f, r, a, A, u),
                            I = new Uint8Array(n * r * 4);
                        return (
                            m(e, I, i, r, n, g),
                            p(I, h, r, n, a, l),
                            c ||
                                (function (t, e, i) {
                                    for (
                                        var r = 3, n = (e * i * 4) | 0;
                                        r < n;

                                    )
                                        (t[r] = 255), (r = (r + 4) | 0);
                                })(h, n, a),
                            h
                        );
                    };
                },
                { './convolve': 2, './resize_filter_gen': 6 },
            ],
            6: [
                function (t, e, i) {
                    'use strict';
                    var M = t('./resize_filter_info'),
                        r = 14;
                    function U(t) {
                        return Math.round(t * ((1 << r) - 1));
                    }
                    e.exports = function (t, e, i, r, n) {
                        var a,
                            o,
                            A,
                            s,
                            u,
                            h,
                            f,
                            c,
                            g,
                            l,
                            I,
                            d,
                            m,
                            p,
                            w,
                            B,
                            b,
                            E = M[t].filter,
                            _ = 1 / r,
                            y = Math.min(1, r),
                            C = M[t].win / y,
                            Q = Math.floor(2 * (C + 1)),
                            v = new Int16Array((Q + 2) * i),
                            x = 0,
                            D = !v.subarray || !v.set;
                        for (a = 0; a < i; a++) {
                            for (
                                o = (a + 0.5) * _ + n,
                                    A = Math.max(0, Math.floor(o - C)),
                                    u =
                                        (s = Math.min(
                                            e - 1,
                                            Math.ceil(o + C)
                                        )) -
                                        A +
                                        1,
                                    h = new Float32Array(u),
                                    f = new Int16Array(u),
                                    g = A,
                                    l = c = 0;
                                g <= s;
                                g++, l++
                            )
                                (c += I = E((g + 0.5 - o) * y)), (h[l] = I);
                            for (l = d = 0; l < h.length; l++)
                                (d += m = h[l] / c), (f[l] = U(m));
                            for (
                                f[i >> 1] += U(1 - d), p = 0;
                                p < f.length && 0 === f[p];

                            )
                                p++;
                            if (p < f.length) {
                                for (w = f.length - 1; 0 < w && 0 === f[w]; )
                                    w--;
                                if (
                                    ((B = A + p),
                                    (b = w - p + 1),
                                    (v[x++] = B),
                                    (v[x++] = b),
                                    D)
                                )
                                    for (l = p; l <= w; l++) v[x++] = f[l];
                                else v.set(f.subarray(p, w + 1), x), (x += b);
                            } else (v[x++] = 0), (v[x++] = 0);
                        }
                        return v;
                    };
                },
                { './resize_filter_info': 7 },
            ],
            7: [
                function (t, e, i) {
                    'use strict';
                    e.exports = [
                        {
                            win: 0.5,
                            filter: function (t) {
                                return -0.5 <= t && t < 0.5 ? 1 : 0;
                            },
                        },
                        {
                            win: 1,
                            filter: function (t) {
                                if (t <= -1 || 1 <= t) return 0;
                                if (-1.1920929e-7 < t && t < 1.1920929e-7)
                                    return 1;
                                var e = t * Math.PI;
                                return (
                                    (Math.sin(e) / e) *
                                    (0.54 + 0.46 * Math.cos(e / 1))
                                );
                            },
                        },
                        {
                            win: 2,
                            filter: function (t) {
                                if (t <= -2 || 2 <= t) return 0;
                                if (-1.1920929e-7 < t && t < 1.1920929e-7)
                                    return 1;
                                var e = t * Math.PI;
                                return (
                                    ((Math.sin(e) / e) * Math.sin(e / 2)) /
                                    (e / 2)
                                );
                            },
                        },
                        {
                            win: 3,
                            filter: function (t) {
                                if (t <= -3 || 3 <= t) return 0;
                                if (-1.1920929e-7 < t && t < 1.1920929e-7)
                                    return 1;
                                var e = t * Math.PI;
                                return (
                                    ((Math.sin(e) / e) * Math.sin(e / 3)) /
                                    (e / 3)
                                );
                            },
                        },
                    ];
                },
                {},
            ],
            8: [
                function (t, e, i) {
                    'use strict';
                    var _ = t('./resize_filter_gen');
                    var A = !0;
                    try {
                        A =
                            1 ===
                            new Uint32Array(
                                new Uint8Array([1, 0, 0, 0]).buffer
                            )[0];
                    } catch (t) {}
                    function y(t, e, i) {
                        if (A)
                            e.set(
                                ((r = t),
                                new Uint8Array(r.buffer, 0, r.byteLength)),
                                i
                            );
                        else
                            for (var r, n = i, a = 0; a < t.length; a++) {
                                var o = t[a];
                                (e[n++] = 255 & o), (e[n++] = (o >> 8) & 255);
                            }
                    }
                    e.exports = function (t) {
                        var e = t.src,
                            i = t.width,
                            r = t.height,
                            n = t.toWidth,
                            a = t.toHeight,
                            o = t.scaleX || t.toWidth / t.width,
                            A = t.scaleY || t.toHeight / t.height,
                            s = t.offsetX || 0,
                            u = t.offsetY || 0,
                            h = t.dest || new Uint8Array(n * a * 4),
                            f = void 0 === t.quality ? 3 : t.quality,
                            c = t.alpha || !1,
                            g = _(f, i, n, o, s),
                            l = _(f, r, a, A, u),
                            I = this.__align(
                                0 + Math.max(e.byteLength, h.byteLength)
                            ),
                            d = this.__align(I + r * n * 4),
                            m = this.__align(d + g.byteLength),
                            p = m + l.byteLength,
                            w = this.__instance('resize', p),
                            B = new Uint8Array(this.__memory.buffer),
                            b = new Uint32Array(this.__memory.buffer),
                            E = new Uint32Array(e.buffer);
                        return (
                            b.set(E),
                            y(g, B, d),
                            y(l, B, m),
                            (w.exports.convolveHV || w.exports._convolveHV)(
                                d,
                                m,
                                I,
                                i,
                                r,
                                n,
                                a
                            ),
                            new Uint32Array(h.buffer).set(
                                new Uint32Array(this.__memory.buffer, 0, a * n)
                            ),
                            c ||
                                (function (t, e, i) {
                                    for (
                                        var r = 3, n = (e * i * 4) | 0;
                                        r < n;

                                    )
                                        (t[r] = 255), (r = (r + 4) | 0);
                                })(h, n, a),
                            h
                        );
                    };
                },
                { './resize_filter_gen': 6 },
            ],
            9: [
                function (t, e, i) {
                    'use strict';
                    function r(t, e) {
                        (this.create = t),
                            (this.available = []),
                            (this.acquired = {}),
                            (this.lastId = 1),
                            (this.timeoutId = 0),
                            (this.idle = e || 2e3);
                    }
                    (r.prototype.acquire = function () {
                        var t,
                            e = this;
                        return (
                            0 !== this.available.length
                                ? (t = this.available.pop())
                                : (((t = this.create()).id = this.lastId++),
                                  (t.release = function () {
                                      return e.release(t);
                                  })),
                            (this.acquired[t.id] = t)
                        );
                    }),
                        (r.prototype.release = function (t) {
                            var e = this;
                            delete this.acquired[t.id],
                                (t.lastUsed = Date.now()),
                                this.available.push(t),
                                0 === this.timeoutId &&
                                    (this.timeoutId = setTimeout(function () {
                                        return e.gc();
                                    }, 100));
                        }),
                        (r.prototype.gc = function () {
                            var e = this,
                                i = Date.now();
                            (this.available = this.available.filter(function (
                                t
                            ) {
                                return (
                                    !(i - t.lastUsed > e.idle) ||
                                    (t.destroy(), !1)
                                );
                            })),
                                0 !== this.available.length
                                    ? (this.timeoutId = setTimeout(function () {
                                          return e.gc();
                                      }, 100))
                                    : (this.timeoutId = 0);
                        }),
                        (e.exports = r);
                },
                {},
            ],
            10: [
                function (t, e, i) {
                    'use strict';
                    e.exports = function (t, e, i, r, n, a) {
                        var o = i / t,
                            A = r / e,
                            s = (2 * a + 2 + 1) / n;
                        if (0.5 < s) return [[i, r]];
                        var u = Math.ceil(
                            Math.log(Math.min(o, A)) / Math.log(s)
                        );
                        if (u <= 1) return [[i, r]];
                        for (var h = [], f = 0; f < u; f++) {
                            var c = Math.round(
                                    Math.pow(
                                        Math.pow(t, u - f - 1) *
                                            Math.pow(i, f + 1),
                                        1 / u
                                    )
                                ),
                                g = Math.round(
                                    Math.pow(
                                        Math.pow(e, u - f - 1) *
                                            Math.pow(r, f + 1),
                                        1 / u
                                    )
                                );
                            h.push([c, g]);
                        }
                        return h;
                    };
                },
                {},
            ],
            11: [
                function (t, e, i) {
                    'use strict';
                    var r = 1e-5;
                    function g(t) {
                        var e = Math.round(t);
                        return Math.abs(t - e) < r ? e : Math.floor(t);
                    }
                    function l(t) {
                        var e = Math.round(t);
                        return Math.abs(t - e) < r ? e : Math.ceil(t);
                    }
                    e.exports = function (t) {
                        var e,
                            i,
                            r,
                            n,
                            a,
                            o,
                            A = t.toWidth / t.width,
                            s = t.toHeight / t.height,
                            u = g(t.srcTileSize * A) - 2 * t.destTileBorder,
                            h = g(t.srcTileSize * s) - 2 * t.destTileBorder;
                        if (u < 1 || h < 1)
                            throw new Error(
                                'Internal error in pica: target tile width/height is too small.'
                            );
                        var f,
                            c = [];
                        for (n = 0; n < t.toHeight; n += h)
                            for (r = 0; r < t.toWidth; r += u)
                                (e = r - t.destTileBorder) < 0 && (e = 0),
                                    e + (a = r + u + t.destTileBorder - e) >=
                                        t.toWidth && (a = t.toWidth - e),
                                    (i = n - t.destTileBorder) < 0 && (i = 0),
                                    i + (o = n + h + t.destTileBorder - i) >=
                                        t.toHeight && (o = t.toHeight - i),
                                    (f = {
                                        toX: e,
                                        toY: i,
                                        toWidth: a,
                                        toHeight: o,
                                        toInnerX: r,
                                        toInnerY: n,
                                        toInnerWidth: u,
                                        toInnerHeight: h,
                                        offsetX: e / A - g(e / A),
                                        offsetY: i / s - g(i / s),
                                        scaleX: A,
                                        scaleY: s,
                                        x: g(e / A),
                                        y: g(i / s),
                                        width: l(a / A),
                                        height: l(o / s),
                                    }),
                                    c.push(f);
                        return c;
                    };
                },
                {},
            ],
            12: [
                function (t, e, i) {
                    'use strict';
                    function r(t) {
                        return Object.prototype.toString.call(t);
                    }
                    (e.exports.isCanvas = function (t) {
                        var e = r(t);
                        return (
                            '[object HTMLCanvasElement]' === e ||
                            '[object Canvas]' === e
                        );
                    }),
                        (e.exports.isImage = function (t) {
                            return '[object HTMLImageElement]' === r(t);
                        }),
                        (e.exports.limiter = function (t) {
                            var r = 0,
                                n = [];
                            function a() {
                                r < t && n.length && (r++, n.shift()());
                            }
                            return function (t) {
                                return new Promise(function (e, i) {
                                    n.push(function () {
                                        t().then(
                                            function (t) {
                                                e(t), r--, a();
                                            },
                                            function (t) {
                                                i(t), r--, a();
                                            }
                                        );
                                    }),
                                        a();
                                });
                            };
                        }),
                        (e.exports.cib_quality_name = function (t) {
                            switch (t) {
                                case 0:
                                    return 'pixelated';
                                case 1:
                                    return 'low';
                                case 2:
                                    return 'medium';
                            }
                            return 'high';
                        }),
                        (e.exports.cib_support = function () {
                            return Promise.resolve()
                                .then(function () {
                                    if (
                                        'undefined' ==
                                            typeof createImageBitmap ||
                                        'undefined' == typeof document
                                    )
                                        return !1;
                                    var i = document.createElement('canvas');
                                    return (
                                        (i.width = 100),
                                        (i.height = 100),
                                        createImageBitmap(i, 0, 0, 100, 100, {
                                            resizeWidth: 10,
                                            resizeHeight: 10,
                                            resizeQuality: 'high',
                                        }).then(function (t) {
                                            var e = 10 === t.width;
                                            return t.close(), (i = null), e;
                                        })
                                    );
                                })
                                .catch(function () {
                                    return !1;
                                });
                        });
                },
                {},
            ],
            13: [
                function (t, e, i) {
                    'use strict';
                    e.exports = function () {
                        var r,
                            n = t('./mathlib');
                        onmessage = function (t) {
                            var e = t.data.opts;
                            r || (r = new n(t.data.features));
                            var i = r.resizeAndUnsharp(e);
                            postMessage({ result: i }, [i.buffer]);
                        };
                    };
                },
                { './mathlib': 1 },
            ],
            14: [
                function (t, e, i) {
                    var A, s, u, h, f, c;
                    function g(t, e, i, r, n, a) {
                        var o, A, s, u, h, f, c, g, l, I, d, m, p, w;
                        for (l = 0; l < a; l++) {
                            for (
                                g = 0,
                                    u = h = (o = t[(f = (c = l) * n)]) * r[6],
                                    d = r[0],
                                    m = r[1],
                                    p = r[4],
                                    w = r[5],
                                    I = 0;
                                I < n;
                                I++
                            )
                                (s = (A = t[f]) * d + o * m + u * p + h * w),
                                    (h = u),
                                    (u = s),
                                    (o = A),
                                    (i[g] = u),
                                    g++,
                                    f++;
                            for (
                                g--,
                                    c += a * (n - 1),
                                    u = h = (o = t[--f]) * r[7],
                                    A = o,
                                    d = r[2],
                                    m = r[3],
                                    I = n - 1;
                                0 <= I;
                                I--
                            )
                                (s = A * d + o * m + u * p + h * w),
                                    (h = u),
                                    (u = s),
                                    (o = A),
                                    (A = t[f]),
                                    (e[c] = i[g] + u),
                                    f--,
                                    g--,
                                    (c -= a);
                        }
                    }
                    e.exports = function (t, e, i, r) {
                        if (r) {
                            var n = new Uint16Array(t.length),
                                a = new Float32Array(Math.max(e, i)),
                                o = (function (t) {
                                    t < 0.5 && (t = 0.5);
                                    var e = Math.exp(0.527076) / t,
                                        i = Math.exp(-e),
                                        r = Math.exp(-2 * e),
                                        n =
                                            ((1 - i) * (1 - i)) /
                                            (1 + 2 * e * i - r);
                                    return (
                                        (s = (A = n) * (e - 1) * i),
                                        (u = n * (e + 1) * i),
                                        (h = -n * r),
                                        (f = 2 * i),
                                        (c = -r),
                                        new Float32Array([
                                            A,
                                            s,
                                            u,
                                            h,
                                            f,
                                            c,
                                            (A + s) / (1 - f - c),
                                            (u + h) / (1 - f - c),
                                        ])
                                    );
                                })(r);
                            g(t, n, a, o, e, i), g(n, t, a, o, i, e);
                        }
                    };
                },
                {},
            ],
            15: [
                function (t, e, i) {
                    'function' == typeof Object.create
                        ? (e.exports = function (t, e) {
                              (t.super_ = e),
                                  (t.prototype = Object.create(e.prototype, {
                                      constructor: {
                                          value: t,
                                          enumerable: !1,
                                          writable: !0,
                                          configurable: !0,
                                      },
                                  }));
                          })
                        : (e.exports = function (t, e) {
                              t.super_ = e;
                              var i = function () {};
                              (i.prototype = e.prototype),
                                  (t.prototype = new i()),
                                  (t.prototype.constructor = t);
                          });
                },
                {},
            ],
            16: [
                function (t, e, i) {
                    'use strict';
                    var a = t('object-assign'),
                        r = t('./lib/base64decode'),
                        n = t('./lib/wa_detect'),
                        o = { js: !0, wasm: !0 };
                    function A(t) {
                        if (!(this instanceof A)) return new A(t);
                        var e = a({}, o, t || {});
                        if (
                            ((this.options = e),
                            (this.__cache = {}),
                            (this.has_wasm = n()),
                            (this.__init_promise = null),
                            (this.__modules = e.modules || {}),
                            (this.__memory = null),
                            (this.__wasm = {}),
                            (this.__isLE =
                                1 ===
                                new Uint32Array(
                                    new Uint8Array([1, 0, 0, 0]).buffer
                                )[0]),
                            !this.options.js && !this.options.wasm)
                        )
                            throw new Error(
                                'mathlib: at least "js" or "wasm" should be enabled'
                            );
                    }
                    (A.prototype.use = function (t) {
                        return (
                            (this.__modules[t.name] = t),
                            this.has_wasm && this.options.wasm && t.wasm_fn
                                ? (this[t.name] = t.wasm_fn)
                                : (this[t.name] = t.fn),
                            this
                        );
                    }),
                        (A.prototype.init = function () {
                            if (this.__init_promise) return this.__init_promise;
                            if (
                                !this.options.js &&
                                this.options.wasm &&
                                !this.has_wasm
                            )
                                return Promise.reject(
                                    new Error(
                                        'mathlib: only "wasm" was enabled, but it\'s not supported'
                                    )
                                );
                            var i = this;
                            return (
                                (this.__init_promise = Promise.all(
                                    Object.keys(i.__modules).map(function (e) {
                                        var t = i.__modules[e];
                                        return i.has_wasm &&
                                            i.options.wasm &&
                                            t.wasm_fn
                                            ? i.__wasm[e]
                                                ? null
                                                : WebAssembly.compile(
                                                      i.__base64decode(
                                                          t.wasm_src
                                                      )
                                                  ).then(function (t) {
                                                      i.__wasm[e] = t;
                                                  })
                                            : null;
                                    })
                                ).then(function () {
                                    return i;
                                })),
                                this.__init_promise
                            );
                        }),
                        (A.prototype.__base64decode = r),
                        (A.prototype.__reallocate = function (t) {
                            if (!this.__memory)
                                return (
                                    (this.__memory = new WebAssembly.Memory({
                                        initial: Math.ceil(t / 65536),
                                    })),
                                    this.__memory
                                );
                            var e = this.__memory.buffer.byteLength;
                            return (
                                e < t &&
                                    this.__memory.grow(
                                        Math.ceil((t - e) / 65536)
                                    ),
                                this.__memory
                            );
                        }),
                        (A.prototype.__instance = function (t, e, i) {
                            if ((e && this.__reallocate(e), !this.__wasm[t])) {
                                var r = this.__modules[t];
                                this.__wasm[t] = new WebAssembly.Module(
                                    this.__base64decode(r.wasm_src)
                                );
                            }
                            if (!this.__cache[t]) {
                                var n = {
                                    memoryBase: 0,
                                    memory: this.__memory,
                                    tableBase: 0,
                                    table: new WebAssembly.Table({
                                        initial: 0,
                                        element: 'anyfunc',
                                    }),
                                };
                                this.__cache[
                                    t
                                ] = new WebAssembly.Instance(this.__wasm[t], {
                                    env: a(n, i || {}),
                                });
                            }
                            return this.__cache[t];
                        }),
                        (A.prototype.__align = function (t, e) {
                            var i = t % (e = e || 8);
                            return t + (i ? e - i : 0);
                        }),
                        (e.exports = A);
                },
                {
                    './lib/base64decode': 17,
                    './lib/wa_detect': 23,
                    'object-assign': 24,
                },
            ],
            17: [
                function (t, e, i) {
                    'use strict';
                    e.exports = function (t) {
                        for (
                            var e = t.replace(/[\r\n=]/g, ''),
                                i = e.length,
                                r = new Uint8Array((3 * i) >> 2),
                                n = 0,
                                a = 0,
                                o = 0;
                            o < i;
                            o++
                        )
                            o % 4 == 0 &&
                                o &&
                                ((r[a++] = (n >> 16) & 255),
                                (r[a++] = (n >> 8) & 255),
                                (r[a++] = 255 & n)),
                                (n =
                                    (n << 6) |
                                    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.indexOf(
                                        e.charAt(o)
                                    ));
                        var A = (i % 4) * 6;
                        return (
                            0 === A
                                ? ((r[a++] = (n >> 16) & 255),
                                  (r[a++] = (n >> 8) & 255),
                                  (r[a++] = 255 & n))
                                : 18 === A
                                ? ((r[a++] = (n >> 10) & 255),
                                  (r[a++] = (n >> 2) & 255))
                                : 12 === A && (r[a++] = (n >> 4) & 255),
                            r
                        );
                    };
                },
                {},
            ],
            18: [
                function (t, e, i) {
                    'use strict';
                    e.exports = function (t, e, i) {
                        for (
                            var r,
                                n,
                                a,
                                o,
                                A,
                                s = e * i,
                                u = new Uint16Array(s),
                                h = 0;
                            h < s;
                            h++
                        )
                            (r = t[4 * h]),
                                (n = t[4 * h + 1]),
                                (a = t[4 * h + 2]),
                                (A =
                                    n <= r && a <= r
                                        ? r
                                        : a <= n && r <= n
                                        ? n
                                        : a),
                                (o =
                                    r <= n && r <= a
                                        ? r
                                        : n <= a && n <= r
                                        ? n
                                        : a),
                                (u[h] = (257 * (A + o)) >> 1);
                        return u;
                    };
                },
                {},
            ],
            19: [
                function (t, e, i) {
                    'use strict';
                    e.exports = {
                        name: 'unsharp_mask',
                        fn: t('./unsharp_mask'),
                        wasm_fn: t('./unsharp_mask_wasm'),
                        wasm_src: t('./unsharp_mask_wasm_base64'),
                    };
                },
                {
                    './unsharp_mask': 20,
                    './unsharp_mask_wasm': 21,
                    './unsharp_mask_wasm_base64': 22,
                },
            ],
            20: [
                function (t, e, i) {
                    'use strict';
                    var C = t('glur/mono16'),
                        Q = t('./hsl_l16');
                    e.exports = function (t, e, i, r, n, a) {
                        var o, A, s, u, h, f, c, g, l, I, d, m, p;
                        if (!(0 === r || n < 0.5)) {
                            2 < n && (n = 2);
                            var w = Q(t, e, i),
                                B = new Uint16Array(w);
                            C(B, e, i, n);
                            for (
                                var b = ((r / 100) * 4096 + 0.5) | 0,
                                    E = (257 * a) | 0,
                                    _ = e * i,
                                    y = 0;
                                y < _;
                                y++
                            )
                                (m = 2 * (w[y] - B[y])),
                                    Math.abs(m) >= E &&
                                        ((o = t[(p = 4 * y)]),
                                        (A = t[p + 1]),
                                        (s = t[p + 2]),
                                        (f =
                                            (257 *
                                                ((g =
                                                    A <= o && s <= o
                                                        ? o
                                                        : o <= A && s <= A
                                                        ? A
                                                        : s) +
                                                    (c =
                                                        o <= A && o <= s
                                                            ? o
                                                            : A <= o && A <= s
                                                            ? A
                                                            : s))) >>
                                            1),
                                        (u =
                                            c === g
                                                ? (h = 0)
                                                : ((h =
                                                      f <= 32767
                                                          ? ((4095 * (g - c)) /
                                                                (g + c)) |
                                                            0
                                                          : ((4095 * (g - c)) /
                                                                (510 - g - c)) |
                                                            0),
                                                  o === g
                                                      ? ((65535 * (A - s)) /
                                                            (6 * (g - c))) |
                                                        0
                                                      : A === g
                                                      ? 21845 +
                                                        (((65535 * (s - o)) /
                                                            (6 * (g - c))) |
                                                            0)
                                                      : 43690 +
                                                        (((65535 * (o - A)) /
                                                            (6 * (g - c))) |
                                                            0))),
                                        65535 < (f += (b * m + 2048) >> 12)
                                            ? (f = 65535)
                                            : f < 0 && (f = 0),
                                        0 === h
                                            ? (o = A = s = f >> 8)
                                            : ((l =
                                                  (2 * f -
                                                      (I =
                                                          f <= 32767
                                                              ? (f *
                                                                    (4096 + h) +
                                                                    2048) >>
                                                                12
                                                              : f +
                                                                (((65535 - f) *
                                                                    h +
                                                                    2048) >>
                                                                    12))) >>
                                                  8),
                                              (I >>= 8),
                                              (o =
                                                  43690 <=
                                                  (d = (u + 21845) & 65535)
                                                      ? l
                                                      : 32767 <= d
                                                      ? l +
                                                        ((6 *
                                                            (I - l) *
                                                            (43690 - d) +
                                                            32768) >>
                                                            16)
                                                      : 10922 <= d
                                                      ? I
                                                      : l +
                                                        ((6 * (I - l) * d +
                                                            32768) >>
                                                            16)),
                                              (A =
                                                  43690 <= (d = 65535 & u)
                                                      ? l
                                                      : 32767 <= d
                                                      ? l +
                                                        ((6 *
                                                            (I - l) *
                                                            (43690 - d) +
                                                            32768) >>
                                                            16)
                                                      : 10922 <= d
                                                      ? I
                                                      : l +
                                                        ((6 * (I - l) * d +
                                                            32768) >>
                                                            16)),
                                              (s =
                                                  43690 <=
                                                  (d = (u - 21845) & 65535)
                                                      ? l
                                                      : 32767 <= d
                                                      ? l +
                                                        ((6 *
                                                            (I - l) *
                                                            (43690 - d) +
                                                            32768) >>
                                                            16)
                                                      : 10922 <= d
                                                      ? I
                                                      : l +
                                                        ((6 * (I - l) * d +
                                                            32768) >>
                                                            16))),
                                        (t[p] = o),
                                        (t[p + 1] = A),
                                        (t[p + 2] = s));
                        }
                    };
                },
                { './hsl_l16': 18, 'glur/mono16': 14 },
            ],
            21: [
                function (t, e, i) {
                    'use strict';
                    e.exports = function (t, e, i, r, n, a) {
                        if (!(0 === r || n < 0.5)) {
                            2 < n && (n = 2);
                            var o = e * i,
                                A = 4 * o,
                                s = 2 * o,
                                u = 2 * o,
                                h = 4 * Math.max(e, i),
                                f = A,
                                c = f + s,
                                g = c + u,
                                l = g + u,
                                I = l + h,
                                d = this.__instance(
                                    'unsharp_mask',
                                    A + s + 2 * u + h + 32,
                                    { exp: Math.exp }
                                ),
                                m = new Uint32Array(t.buffer);
                            new Uint32Array(this.__memory.buffer).set(m);
                            var p = d.exports.hsl_l16 || d.exports._hsl_l16;
                            p(0, f, e, i),
                                (p =
                                    d.exports.blurMono16 ||
                                    d.exports._blurMono16)(
                                    f,
                                    c,
                                    g,
                                    l,
                                    I,
                                    e,
                                    i,
                                    n
                                ),
                                (p = d.exports.unsharp || d.exports._unsharp)(
                                    0,
                                    0,
                                    f,
                                    c,
                                    e,
                                    i,
                                    r,
                                    a
                                ),
                                m.set(
                                    new Uint32Array(this.__memory.buffer, 0, o)
                                );
                        }
                    };
                },
                {},
            ],
            22: [
                function (t, e, i) {
                    'use strict';
                    e.exports =
                        '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';
                },
                {},
            ],
            23: [
                function (t, e, i) {
                    'use strict';
                    var r;
                    e.exports = function () {
                        if (void 0 !== r) return r;
                        if (((r = !1), 'undefined' == typeof WebAssembly))
                            return r;
                        try {
                            var t = new Uint8Array([
                                    0,
                                    97,
                                    115,
                                    109,
                                    1,
                                    0,
                                    0,
                                    0,
                                    1,
                                    6,
                                    1,
                                    96,
                                    1,
                                    127,
                                    1,
                                    127,
                                    3,
                                    2,
                                    1,
                                    0,
                                    5,
                                    3,
                                    1,
                                    0,
                                    1,
                                    7,
                                    8,
                                    1,
                                    4,
                                    116,
                                    101,
                                    115,
                                    116,
                                    0,
                                    0,
                                    10,
                                    16,
                                    1,
                                    14,
                                    0,
                                    32,
                                    0,
                                    65,
                                    1,
                                    54,
                                    2,
                                    0,
                                    32,
                                    0,
                                    40,
                                    2,
                                    0,
                                    11,
                                ]),
                                e = new WebAssembly.Module(t);
                            return (
                                0 !==
                                    new WebAssembly.Instance(
                                        e,
                                        {}
                                    ).exports.test(4) && (r = !0),
                                r
                            );
                        } catch (t) {}
                        return r;
                    };
                },
                {},
            ],
            24: [
                function (t, e, i) {
                    'use strict';
                    var s = Object.getOwnPropertySymbols,
                        u = Object.prototype.hasOwnProperty,
                        h = Object.prototype.propertyIsEnumerable;
                    e.exports = (function () {
                        try {
                            if (!Object.assign) return !1;
                            var t = new String('abc');
                            if (
                                ((t[5] = 'de'),
                                '5' === Object.getOwnPropertyNames(t)[0])
                            )
                                return !1;
                            for (var e = {}, i = 0; i < 10; i++)
                                e['_' + String.fromCharCode(i)] = i;
                            if (
                                '0123456789' !==
                                Object.getOwnPropertyNames(e)
                                    .map(function (t) {
                                        return e[t];
                                    })
                                    .join('')
                            )
                                return !1;
                            var r = {};
                            return (
                                'abcdefghijklmnopqrst'
                                    .split('')
                                    .forEach(function (t) {
                                        r[t] = t;
                                    }),
                                'abcdefghijklmnopqrst' ===
                                    Object.keys(Object.assign({}, r)).join('')
                            );
                        } catch (t) {
                            return !1;
                        }
                    })()
                        ? Object.assign
                        : function (t, e) {
                              for (
                                  var i,
                                      r,
                                      n = (function (t) {
                                          if (null == t)
                                              throw new TypeError(
                                                  'Object.assign cannot be called with null or undefined'
                                              );
                                          return Object(t);
                                      })(t),
                                      a = 1;
                                  a < arguments.length;
                                  a++
                              ) {
                                  for (var o in (i = Object(arguments[a])))
                                      u.call(i, o) && (n[o] = i[o]);
                                  if (s) {
                                      r = s(i);
                                      for (var A = 0; A < r.length; A++)
                                          h.call(i, r[A]) &&
                                              (n[r[A]] = i[r[A]]);
                                  }
                              }
                              return n;
                          };
                },
                {},
            ],
            25: [
                function (t, e, i) {
                    var m = arguments[3],
                        p = arguments[4],
                        w = arguments[5],
                        B = JSON.stringify;
                    e.exports = function (t, e) {
                        for (
                            var i, r = Object.keys(w), n = 0, a = r.length;
                            n < a;
                            n++
                        ) {
                            var o = r[n],
                                A = w[o].exports;
                            if (A === t || (A && A.default === t)) {
                                i = o;
                                break;
                            }
                        }
                        if (!i) {
                            i = Math.floor(
                                Math.pow(16, 8) * Math.random()
                            ).toString(16);
                            var s = {};
                            for (n = 0, a = r.length; n < a; n++) {
                                s[(o = r[n])] = o;
                            }
                            p[i] = [
                                'function(require,module,exports){' +
                                    t +
                                    '(self); }',
                                s,
                            ];
                        }
                        var u = Math.floor(
                                Math.pow(16, 8) * Math.random()
                            ).toString(16),
                            h = {};
                        (h[i] = i),
                            (p[u] = [
                                'function(require,module,exports){var f = require(' +
                                    B(i) +
                                    ');(f.default ? f.default : f)(self);}',
                                h,
                            ]);
                        var f = {};
                        !(function t(e) {
                            f[e] = !0;
                            for (var i in p[e][1]) {
                                var r = p[e][1][i];
                                f[r] || t(r);
                            }
                        })(u);
                        var c =
                                '(' +
                                m +
                                ')({' +
                                Object.keys(f)
                                    .map(function (t) {
                                        return (
                                            B(t) +
                                            ':[' +
                                            p[t][0] +
                                            ',' +
                                            B(p[t][1]) +
                                            ']'
                                        );
                                    })
                                    .join(',') +
                                '},{},[' +
                                B(u) +
                                '])',
                            g =
                                window.URL ||
                                window.webkitURL ||
                                window.mozURL ||
                                window.msURL,
                            l = new Blob([c], { type: 'text/javascript' });
                        if (e && e.bare) return l;
                        var I = g.createObjectURL(l),
                            d = new Worker(I);
                        return (d.objectURL = I), d;
                    };
                },
                {},
            ],
            '/': [
                function (a, t, e) {
                    'use strict';
                    function d(t, e) {
                        return (
                            (function (t) {
                                if (Array.isArray(t)) return t;
                            })(t) ||
                            (function (t, e) {
                                var i = [],
                                    r = !0,
                                    n = !1,
                                    a = void 0;
                                try {
                                    for (
                                        var o, A = t[Symbol.iterator]();
                                        !(r = (o = A.next()).done) &&
                                        (i.push(o.value), !e || i.length !== e);
                                        r = !0
                                    );
                                } catch (t) {
                                    (n = !0), (a = t);
                                } finally {
                                    try {
                                        r || null == A.return || A.return();
                                    } finally {
                                        if (n) throw a;
                                    }
                                }
                                return i;
                            })(t, e) ||
                            (function () {
                                throw new TypeError(
                                    'Invalid attempt to destructure non-iterable instance'
                                );
                            })()
                        );
                    }
                    var m = a('object-assign'),
                        i = a('webworkify'),
                        o = a('./lib/mathlib'),
                        A = a('./lib/pool'),
                        p = a('./lib/utils'),
                        r = a('./lib/worker'),
                        s = a('./lib/stepper'),
                        w = a('./lib/tiler'),
                        u = {},
                        B = !1;
                    try {
                        'undefined' != typeof navigator &&
                            navigator.userAgent &&
                            (B = 0 <= navigator.userAgent.indexOf('Safari'));
                    } catch (t) {}
                    var n = 1;
                    'undefined' != typeof navigator &&
                        (n = Math.min(navigator.hardwareConcurrency || 1, 4));
                    var b,
                        E,
                        h = {
                            tile: 1024,
                            concurrency: n,
                            features: ['js', 'wasm', 'ww'],
                            idle: 2e3,
                        },
                        f = {
                            quality: 3,
                            alpha: !1,
                            unsharpAmount: 0,
                            unsharpRadius: 0,
                            unsharpThreshold: 0,
                        };
                    function c() {
                        return {
                            value: i(r),
                            destroy: function () {
                                if (
                                    (this.value.terminate(),
                                    'undefined' != typeof window)
                                ) {
                                    var t =
                                        window.URL ||
                                        window.webkitURL ||
                                        window.mozURL ||
                                        window.msURL;
                                    t &&
                                        t.revokeObjectURL &&
                                        this.value.objectURL &&
                                        t.revokeObjectURL(this.value.objectURL);
                                }
                            },
                        };
                    }
                    function g(t) {
                        if (!(this instanceof g)) return new g(t);
                        this.options = m({}, h, t || {});
                        var e = 'lk_'.concat(this.options.concurrency);
                        (this.__limit =
                            u[e] || p.limiter(this.options.concurrency)),
                            u[e] || (u[e] = this.__limit),
                            (this.features = {
                                js: !1,
                                wasm: !1,
                                cib: !1,
                                ww: !1,
                            }),
                            (this.__workersPool = null),
                            (this.__requested_features = []),
                            (this.__mathlib = null);
                    }
                    (g.prototype.init = function () {
                        var e = this;
                        if (this.__initPromise) return this.__initPromise;
                        if (
                            !1 !== b &&
                            !0 !== b &&
                            ((b = !1),
                            'undefined' != typeof ImageData &&
                                'undefined' != typeof Uint8ClampedArray)
                        )
                            try {
                                new ImageData(
                                    new Uint8ClampedArray(400),
                                    10,
                                    10
                                ),
                                    (b = !0);
                            } catch (t) {}
                        !1 !== E &&
                            !0 !== E &&
                            ((E = !1),
                            'undefined' != typeof ImageBitmap &&
                                (ImageBitmap.prototype &&
                                ImageBitmap.prototype.close
                                    ? (E = !0)
                                    : this.debug(
                                          'ImageBitmap does not support .close(), disabled'
                                      )));
                        var i = this.options.features.slice();
                        if (
                            (0 <= i.indexOf('all') &&
                                (i = ['cib', 'wasm', 'js', 'ww']),
                            (this.__requested_features = i),
                            (this.__mathlib = new o(i)),
                            0 <= i.indexOf('ww') &&
                                'undefined' != typeof window &&
                                'Worker' in window)
                        )
                            try {
                                a('webworkify')(function () {}).terminate(),
                                    (this.features.ww = !0);
                                var t = 'wp_'.concat(
                                    JSON.stringify(this.options)
                                );
                                u[t]
                                    ? (this.__workersPool = u[t])
                                    : ((this.__workersPool = new A(
                                          c,
                                          this.options.idle
                                      )),
                                      (u[t] = this.__workersPool));
                            } catch (t) {}
                        var r,
                            n = this.__mathlib.init().then(function (t) {
                                m(e.features, t.features);
                            });
                        return (
                            (r = E
                                ? p.cib_support().then(function (t) {
                                      e.features.cib && i.indexOf('cib') < 0
                                          ? e.debug(
                                                'createImageBitmap() resize supported, but disabled by config'
                                            )
                                          : 0 <= i.indexOf('cib') &&
                                            (e.features.cib = t);
                                  })
                                : Promise.resolve(!1)),
                            (this.__initPromise = Promise.all([n, r]).then(
                                function () {
                                    return e;
                                }
                            )),
                            this.__initPromise
                        );
                    }),
                        (g.prototype.resize = function (t, a, e) {
                            var c = this;
                            this.debug('Start resize...');
                            var o = m({}, f);
                            if (
                                (isNaN(e)
                                    ? e && (o = m(o, e))
                                    : (o = m(o, { quality: e })),
                                (o.toWidth = a.width),
                                (o.toHeight = a.height),
                                (o.width = t.naturalWidth || t.width),
                                (o.height = t.naturalHeight || t.height),
                                0 === a.width || 0 === a.height)
                            )
                                return Promise.reject(
                                    new Error(
                                        'Invalid output size: '
                                            .concat(a.width, 'x')
                                            .concat(a.height)
                                    )
                                );
                            2 < o.unsharpRadius && (o.unsharpRadius = 2);
                            var g = !1,
                                l = null;
                            o.cancelToken &&
                                (l = o.cancelToken.then(
                                    function (t) {
                                        throw ((g = !0), t);
                                    },
                                    function (t) {
                                        throw ((g = !0), t);
                                    }
                                ));
                            var I = Math.ceil(
                                Math.max(3, (2.5 * o.unsharpRadius) | 0)
                            );
                            return this.init().then(function () {
                                if (g) return l;
                                if (c.features.cib) {
                                    var n = a.getContext('2d', {
                                        alpha: Boolean(o.alpha),
                                    });
                                    return (
                                        c.debug(
                                            'Resize via createImageBitmap()'
                                        ),
                                        createImageBitmap(t, {
                                            resizeWidth: o.toWidth,
                                            resizeHeight: o.toHeight,
                                            resizeQuality: p.cib_quality_name(
                                                o.quality
                                            ),
                                        }).then(function (t) {
                                            if (g) return l;
                                            if (!o.unsharpAmount)
                                                return (
                                                    n.drawImage(t, 0, 0),
                                                    t.close(),
                                                    (n = null),
                                                    c.debug('Finished!'),
                                                    a
                                                );
                                            c.debug('Unsharp result');
                                            var e = document.createElement(
                                                'canvas'
                                            );
                                            (e.width = o.toWidth),
                                                (e.height = o.toHeight);
                                            var i = e.getContext('2d', {
                                                alpha: Boolean(o.alpha),
                                            });
                                            i.drawImage(t, 0, 0), t.close();
                                            var r = i.getImageData(
                                                0,
                                                0,
                                                o.toWidth,
                                                o.toHeight
                                            );
                                            return (
                                                c.__mathlib.unsharp(
                                                    r.data,
                                                    o.toWidth,
                                                    o.toHeight,
                                                    o.unsharpAmount,
                                                    o.unsharpRadius,
                                                    o.unsharpThreshold
                                                ),
                                                n.putImageData(r, 0, 0),
                                                (r = i = e = n = null),
                                                c.debug('Finished!'),
                                                a
                                            );
                                        })
                                    );
                                }
                                var h = {},
                                    f = function (a, i, o) {
                                        var A,
                                            s,
                                            u,
                                            r = function (n) {
                                                return c.__limit(function () {
                                                    if (g) return l;
                                                    var r;
                                                    if (p.isCanvas(a))
                                                        c.debug(
                                                            'Get tile pixel data'
                                                        ),
                                                            (r = A.getImageData(
                                                                n.x,
                                                                n.y,
                                                                n.width,
                                                                n.height
                                                            ));
                                                    else {
                                                        c.debug(
                                                            'Draw tile imageBitmap/image to temporary canvas'
                                                        );
                                                        var t = document.createElement(
                                                            'canvas'
                                                        );
                                                        (t.width = n.width),
                                                            (t.height =
                                                                n.height);
                                                        var e = t.getContext(
                                                            '2d',
                                                            {
                                                                alpha: Boolean(
                                                                    o.alpha
                                                                ),
                                                            }
                                                        );
                                                        (e.globalCompositeOperation =
                                                            'copy'),
                                                            e.drawImage(
                                                                s || a,
                                                                n.x,
                                                                n.y,
                                                                n.width,
                                                                n.height,
                                                                0,
                                                                0,
                                                                n.width,
                                                                n.height
                                                            ),
                                                            c.debug(
                                                                'Get tile pixel data'
                                                            ),
                                                            (r = e.getImageData(
                                                                0,
                                                                0,
                                                                n.width,
                                                                n.height
                                                            )),
                                                            (e = t = null);
                                                    }
                                                    var i = {
                                                        src: r.data,
                                                        width: n.width,
                                                        height: n.height,
                                                        toWidth: n.toWidth,
                                                        toHeight: n.toHeight,
                                                        scaleX: n.scaleX,
                                                        scaleY: n.scaleY,
                                                        offsetX: n.offsetX,
                                                        offsetY: n.offsetY,
                                                        quality: o.quality,
                                                        alpha: o.alpha,
                                                        unsharpAmount:
                                                            o.unsharpAmount,
                                                        unsharpRadius:
                                                            o.unsharpRadius,
                                                        unsharpThreshold:
                                                            o.unsharpThreshold,
                                                    };
                                                    return (
                                                        c.debug(
                                                            'Invoke resize math'
                                                        ),
                                                        Promise.resolve()
                                                            .then(function () {
                                                                return (
                                                                    (t = i),
                                                                    Promise.resolve().then(
                                                                        function () {
                                                                            return c
                                                                                .features
                                                                                .ww
                                                                                ? new Promise(
                                                                                      function (
                                                                                          e,
                                                                                          i
                                                                                      ) {
                                                                                          var r = c.__workersPool.acquire();
                                                                                          l &&
                                                                                              l.catch(
                                                                                                  function (
                                                                                                      t
                                                                                                  ) {
                                                                                                      return i(
                                                                                                          t
                                                                                                      );
                                                                                                  }
                                                                                              ),
                                                                                              (r.value.onmessage = function (
                                                                                                  t
                                                                                              ) {
                                                                                                  r.release(),
                                                                                                      t
                                                                                                          .data
                                                                                                          .err
                                                                                                          ? i(
                                                                                                                t
                                                                                                                    .data
                                                                                                                    .err
                                                                                                            )
                                                                                                          : e(
                                                                                                                t
                                                                                                                    .data
                                                                                                                    .result
                                                                                                            );
                                                                                              }),
                                                                                              r.value.postMessage(
                                                                                                  {
                                                                                                      opts: t,
                                                                                                      features:
                                                                                                          c.__requested_features,
                                                                                                      preload: {
                                                                                                          wasm_nodule:
                                                                                                              c
                                                                                                                  .__mathlib
                                                                                                                  .__,
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                      t
                                                                                                          .src
                                                                                                          .buffer,
                                                                                                  ]
                                                                                              );
                                                                                      }
                                                                                  )
                                                                                : c.__mathlib.resizeAndUnsharp(
                                                                                      t,
                                                                                      h
                                                                                  );
                                                                        }
                                                                    )
                                                                );
                                                                var t;
                                                            })
                                                            .then(function (t) {
                                                                if (g) return l;
                                                                var e;
                                                                if (
                                                                    ((r = null),
                                                                    c.debug(
                                                                        'Convert raw rgba tile result to ImageData'
                                                                    ),
                                                                    b)
                                                                )
                                                                    e = new ImageData(
                                                                        new Uint8ClampedArray(
                                                                            t
                                                                        ),
                                                                        n.toWidth,
                                                                        n.toHeight
                                                                    );
                                                                else if (
                                                                    (e = u.createImageData(
                                                                        n.toWidth,
                                                                        n.toHeight
                                                                    )).data.set
                                                                )
                                                                    e.data.set(
                                                                        t
                                                                    );
                                                                else
                                                                    for (
                                                                        var i =
                                                                            e
                                                                                .data
                                                                                .length -
                                                                            1;
                                                                        0 <= i;
                                                                        i--
                                                                    )
                                                                        e.data[
                                                                            i
                                                                        ] =
                                                                            t[
                                                                                i
                                                                            ];
                                                                return (
                                                                    c.debug(
                                                                        'Draw tile'
                                                                    ),
                                                                    B
                                                                        ? u.putImageData(
                                                                              e,
                                                                              n.toX,
                                                                              n.toY,
                                                                              n.toInnerX -
                                                                                  n.toX,
                                                                              n.toInnerY -
                                                                                  n.toY,
                                                                              n.toInnerWidth +
                                                                                  1e-5,
                                                                              n.toInnerHeight +
                                                                                  1e-5
                                                                          )
                                                                        : u.putImageData(
                                                                              e,
                                                                              n.toX,
                                                                              n.toY,
                                                                              n.toInnerX -
                                                                                  n.toX,
                                                                              n.toInnerY -
                                                                                  n.toY,
                                                                              n.toInnerWidth,
                                                                              n.toInnerHeight
                                                                          ),
                                                                    null
                                                                );
                                                            })
                                                    );
                                                });
                                            };
                                        return Promise.resolve()
                                            .then(function () {
                                                if (
                                                    ((u = i.getContext('2d', {
                                                        alpha: Boolean(o.alpha),
                                                    })),
                                                    p.isCanvas(a))
                                                )
                                                    return (
                                                        (A = a.getContext(
                                                            '2d',
                                                            {
                                                                alpha: Boolean(
                                                                    o.alpha
                                                                ),
                                                            }
                                                        )),
                                                        null
                                                    );
                                                if (p.isImage(a))
                                                    return E
                                                        ? (c.debug(
                                                              'Decode image via createImageBitmap'
                                                          ),
                                                          createImageBitmap(
                                                              a
                                                          ).then(function (t) {
                                                              s = t;
                                                          }))
                                                        : null;
                                                throw new Error(
                                                    '".from" should be image or canvas'
                                                );
                                            })
                                            .then(function () {
                                                if (g) return l;
                                                c.debug('Calculate tiles');
                                                var t = w({
                                                    width: o.width,
                                                    height: o.height,
                                                    srcTileSize: c.options.tile,
                                                    toWidth: o.toWidth,
                                                    toHeight: o.toHeight,
                                                    destTileBorder: I,
                                                }).map(function (t) {
                                                    return r(t);
                                                });
                                                function e() {
                                                    s &&
                                                        (s.close(), (s = null));
                                                }
                                                return (
                                                    c.debug('Process tiles'),
                                                    Promise.all(t).then(
                                                        function () {
                                                            return (
                                                                c.debug(
                                                                    'Finished!'
                                                                ),
                                                                e(),
                                                                i
                                                            );
                                                        },
                                                        function (t) {
                                                            throw (e(), t);
                                                        }
                                                    )
                                                );
                                            });
                                    };
                                return (function t(e, i, r, n) {
                                    if (g) return l;
                                    var a,
                                        o = d(e.shift(), 2),
                                        A = o[0],
                                        s = o[1],
                                        u = 0 === e.length;
                                    return (
                                        (n = m({}, n, {
                                            toWidth: A,
                                            toHeight: s,
                                            quality: u
                                                ? n.quality
                                                : Math.min(1, n.quality),
                                        })),
                                        u ||
                                            (((a = document.createElement(
                                                'canvas'
                                            )).width = A),
                                            (a.height = s)),
                                        f(i, u ? r : a, n).then(function () {
                                            return u
                                                ? r
                                                : ((n.width = A),
                                                  (n.height = s),
                                                  t(e, a, r, n));
                                        })
                                    );
                                })(
                                    s(
                                        o.width,
                                        o.height,
                                        o.toWidth,
                                        o.toHeight,
                                        c.options.tile,
                                        I
                                    ),
                                    t,
                                    a,
                                    o
                                );
                            });
                        }),
                        (g.prototype.resizeBuffer = function (t) {
                            var e = this,
                                i = m({}, f, t);
                            return this.init().then(function () {
                                return e.__mathlib.resizeAndUnsharp(i);
                            });
                        }),
                        (g.prototype.toBlob = function (a, o, A) {
                            return (
                                (o = o || 'image/png'),
                                new Promise(function (e) {
                                    if (a.toBlob)
                                        a.toBlob(
                                            function (t) {
                                                return e(t);
                                            },
                                            o,
                                            A
                                        );
                                    else {
                                        for (
                                            var t = atob(
                                                    a
                                                        .toDataURL(o, A)
                                                        .split(',')[1]
                                                ),
                                                i = t.length,
                                                r = new Uint8Array(i),
                                                n = 0;
                                            n < i;
                                            n++
                                        )
                                            r[n] = t.charCodeAt(n);
                                        e(new Blob([r], { type: o }));
                                    }
                                })
                            );
                        }),
                        (g.prototype.debug = function () {}),
                        (t.exports = g);
                },
                {
                    './lib/mathlib': 1,
                    './lib/pool': 9,
                    './lib/stepper': 10,
                    './lib/tiler': 11,
                    './lib/utils': 12,
                    './lib/worker': 13,
                    'object-assign': 24,
                    webworkify: 25,
                },
            ],
        },
        {},
        []
    )('/');
});
